import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=603825b1&scoped=true&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603825b1",
  null
  
)

export default component.exports